import * as React from "react";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Typography from "@mui/material/Typography";
import { Link } from "react-router-dom";
import Stack from "@mui/material/Stack";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";

export default function CustomBreadcrumbMenu({ menu }) {
  const [breadcrumbs, setBreadcrumbs] = React.useState([]);

  function updateBreadcrumbs() {
    if (Object.keys(menu).length > 0) {
      let temp = [];
      for (const [key, value] of Object.entries(menu)) {
        if (value.link !== "") {
          temp.push(generateLink(value.link, key + 1, value.title));
        } else {
          temp.push(generateText(key + 1, value.title));
        }
      }
      setBreadcrumbs(temp);
    }
  }

  const generateLink = (link, key, title) => {
    return (
      <Link
        underline="hover"
        key={key}
        color="inherit"
        to={link}
        style={{ color: "#00A3E0" }}
      >
        {title}
      </Link>
    );
  };
  const generateText = (key, title) => {
    return (
      <Typography key={key} style={{ color: "white" }}>
        {title}
      </Typography>
    );
  };
  React.useEffect(() => {
    updateBreadcrumbs();
  }, [menu]);
  return (
    <Stack spacing={2}>
      <Breadcrumbs
        separator={<NavigateNextIcon fontSize="small" />}
        aria-label="breadcrumb"
        style={{ color: "white" }}
      >
        {breadcrumbs}
      </Breadcrumbs>
    </Stack>
  );
}
